function toggleAnswer(questionNumber) {
    var answer = document.querySelector('.accordion-item:nth-child(' + questionNumber + ') .accordion-answer');
    var icon = document.querySelector('.accordion-item:nth-child(' + questionNumber + ') .accordion-icon');

    answer.style.display = (answer.style.display === 'block') ? 'none' : 'block';
    icon.style.transform = (answer.style.display === 'block') ? 'rotate(0deg)' : 'rotate(180deg)';

    // Close other answers
    var allAnswers = document.querySelectorAll('.accordion-answer');
    var allIcons = document.querySelectorAll('.accordion-icon');
    allAnswers.forEach(function (item) {
        if (item !== answer) {
            item.style.display = 'none';
        }
    });
    allIcons.forEach(function (item) {
        if (item !== icon) {
            item.style.transform = 'rotate(0deg)';
        }
    });
}

function toggleAnswerc(questionNumberc) {
  var answer = document.querySelector('.accordion-itemc:nth-child(' + questionNumberc + ') .accordion-answerc');
  var icon = document.querySelector('.accordion-itemc:nth-child(' + questionNumberc + ') .accordion-iconc');

  answer.style.display = (answer.style.display === 'block') ? 'none' : 'block';
  icon.style.transform = (answer.style.display === 'block') ? 'rotate(0deg)' : 'rotate(180deg)';

  // Close other answers
  var allAnswers = document.querySelectorAll('.accordion-answerc');
  var allIcons = document.querySelectorAll('.accordion-iconc');
  allAnswers.forEach(function (item) {
      if (item !== answer) {
          item.style.display = 'none';
      }
  });
  allIcons.forEach(function (item) {
      if (item !== icon) {
          item.style.transform = 'rotate(0deg)';
      }
  });
}